import type {
  AiPromptContext,
  AiPromptContextIntegration,
  AiPromptContextMention,
  AiPromptContextReference,
} from "@ctrl/controller-rpc";

export type ConversationContextItem =
  | { type: "integration"; item: AiPromptContextIntegration }
  | { type: "mention"; item: AiPromptContextMention }
  | { type: "reference"; item: AiPromptContextReference };

export function removeConversationContextItem(
  context: AiPromptContext,
  removed: ConversationContextItem
): AiPromptContext {
  return {
    integrations:
      removed.type === "integration"
        ? (context.integrations ?? []).filter(
            (integration) =>
              integration.key !== removed.item.key ||
              integration.data !== removed.item.data
          )
        : (context.integrations ?? []),
    mentions:
      removed.type === "mention"
        ? (context.mentions ?? []).filter(
            (mention) =>
              mention.key !== removed.item.key ||
              mention.data !== removed.item.data
          )
        : (context.mentions ?? []),
    references:
      removed.type === "reference"
        ? (context.references ?? []).filter(
            (reference) =>
              reference.key !== removed.item.key ||
              reference.data.kind !== removed.item.data.kind ||
              reference.data.id !== removed.item.data.id
          )
        : (context.references ?? []),
  };
}
